import {
	ArrowUpwardOutlined,
	ErrorOutlineOutlined,
	HelpOutlineOutlined,
	ReportProblemOutlined,
	VerifiedUserOutlined,
} from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { amber, blue, green, red } from '@mui/material/colors'
import { FixedHeaderWithHint } from '../../../../utils/HOC/FixedHeaders'
import { specifyInternalComponent } from '../../../FormBuilderCore/cells/ComponentSpecification'
import { useLayoutCellContext } from '../../../FormBuilderCore/cells/rendering/contexts/LayoutCellContextProvider'
import FieldType from '../../../FormHost/Types/FieldType'
import { BoundingBox } from '../../../Ocr/OcrTypes'

type OcrResultField = {
	confidence?: number
	accepted: boolean
	value: unknown
	labelData: LabelData
}

type LabelData = {
	boundingBox: BoundingBox
	pageNumber: number
	text: string
	hintText: string
}

enum ConfidenceLevel {
	Accepted,
	High,
	Medium,
	Low,
	Unknown,
}

const getConfidenceLevel = (
	confidence: number | undefined,
	accepted: boolean,
): ConfidenceLevel => {
	if (confidence === undefined) return ConfidenceLevel.Unknown
	if (accepted) return ConfidenceLevel.Accepted
	return ConfidenceLevel.Low
}

type OcrResultLayoutProps = {
	results: OcrResultField[]
}

export const OcrResultLayout = (props: OcrResultLayoutProps) => {
	console.log('rendering ocr result layout')
	const context = useLayoutCellContext()

	const cellComponents = context.cellComponents

	return (
		<Box display="flex" flex={1} gap={1} flexDirection="row" flexWrap="wrap">
			{props.results.map((result, index) => (
				<FixedHeaderWithHint
					label={
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="space-between"
							width="100%"
						>
							<Typography variant="subtitle1">
								{result.labelData.text}
							</Typography>
							<Box display="flex" alignItems="center" gap={0.5}>
								<FieldConfidence
									confidence={result.confidence}
									accepted={result.accepted}
								/>
								<Typography variant="body1">{result.confidence}%</Typography>
							</Box>
						</Box>
					}
					hint={result.labelData.hintText}
				>
					<Box marginY={0.5}>{cellComponents[index]}</Box>
				</FixedHeaderWithHint>
			))}
		</Box>
	)
}

type FieldConfidenceProps = {
	confidence?: number
	accepted: boolean
}

const FieldConfidence = (props: FieldConfidenceProps) => {
	const confidenceLevel = getConfidenceLevel(props.confidence, props.accepted)

	return (
		<>
			{confidenceLevel == ConfidenceLevel.Accepted && (
				<VerifiedUserOutlined htmlColor={green[600]} />
			)}
			{confidenceLevel == ConfidenceLevel.High && (
				<ArrowUpwardOutlined htmlColor={green[600]} />
			)}
			{confidenceLevel == ConfidenceLevel.Medium && (
				<ReportProblemOutlined htmlColor={amber[500]} />
			)}
			{confidenceLevel == ConfidenceLevel.Low && (
				<ErrorOutlineOutlined htmlColor={red[500]} />
			)}
			{confidenceLevel == ConfidenceLevel.Unknown && (
				<HelpOutlineOutlined htmlColor={blue[600]} />
			)}
		</>
	)
}

export const OcrResultLayoutElementTag = 'ea73e994-7254-442c-8503-8c4b6ab07112'

const OcrResultLayoutId = '6ed50b8f-4c7c-4847-a15a-80a1effa743b'

export const OcrResultLayoutDefinition = specifyInternalComponent(
	OcrResultLayoutId,
	OcrResultLayout,
	OcrResultLayoutElementTag,
	FieldType.Object,
	{
		results: [],
	},
)
